import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Intuos",
  "description": "",
  "published": "2006-11-20T00:00:00.000Z",
  "redirect_from": ["/blog/intuos/swizec/352"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/includes/editor_upload/Image/precious.jpg"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/precious_t.jpg",
          "alt": "Intuos3",
          "title": "Intuos3"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/includes/editor_upload/Image/tablet_1.png"
      }}><img parentName="a" {...{
          "src": "/includes/editor_upload/Image/tablet_1_t.png",
          "alt": "First tablet",
          "title": "First tablet"
        }}></img></a></p>
    <p>{`Today I've bought a new Wacom Intuos3 simply for the reason that I've wanted a pen tablet for quite a while now and that since I don't have enough money to buy what it was originally meant to buy it was just sitting there doing nothing, might as well spend it on something.`}</p>
    <p>{`So far I've only created one image with it and after the initial trouble of getting used to it, and probably I'll get used to it even more, it was quite fascinating to use. It is much different from using a mouse and only time will tell how quicker and easier the comics will be produced now.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      